import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=e2b15b52&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=e2b15b52&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b15b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2b15b52')) {
      api.createRecord('e2b15b52', component.options)
    } else {
      api.reload('e2b15b52', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=e2b15b52&scoped=true&", function () {
      api.rerender('e2b15b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4TWBw0fvk4dfd/JS/comp/Paginate.vue"
export default component.exports